import React from 'react';
import Carousel from "react-material-ui-carousel";
import {Item} from "./image-carousel";
import InstagramIcon from "@mui/icons-material/Instagram";

const items = ["premium", "pro", "vip"]

const PackageCarousel = ({onInstagramClick}) => {
    const [index, setIndex] = React.useState(0);

    const handleChange = (cur, prev) => {
        setIndex(cur);
    };
    return (
        <div className={"pay-block"}>
            <p>Ընտրեք փաթեթը, ապա սկանավորեք QR-ը իդրամ հավելվածով վճարումն իրականացնելու համար 😍</p>
            <br/>
            <p>Վճարումը կատարելուց հետո վճարման կտրոնը անհրաժեշտ է ուղարկել Միլենա Մելիքսեթյանի ինստագրամյան էջին և ՎԵՐՋ😍 </p>
            <p>Ձեր գրանցումը հաստատված է ✅</p>
            <div className={'insta-wrapper'}>
                <p>Ինստագրամյան էջը` </p>
                <div className={'icon-wrapper'}>
                    <InstagramIcon onClick={onInstagramClick} sx={{color: "#bb003b"}}/>
                </div>
            </div>
            <Carousel
                index={index}
                onChange={handleChange}
                animation="slide"
                swipe={false}
                autoPlay={false}
                navButtonsAlwaysVisible={true}
                activeIndicatorIconButtonProps={{
                    style: {
                        color: "#b31684"
                    }
                }}
                indicatorContainerProps={{
                    style: {
                        padding: "0 10%",
                    }
                }}
                navButtonsWrapperProps={{
                    style: {
                        height: "88%",
                        opacity: 0.6
                    }
                }}
                className="package-carousel"
                height={'88%'}
                back
            >
                {items.map((item, i) => (
                    <Item key={'image' + i} item={item}/>
                ))}
            </Carousel>
        </div>

    );
};

export default PackageCarousel;
